<template>
  <div>
    <a-drawer
      v-if="props.hasDrawer"
      v-model:visible="visible"
      class="custom-class"
      root-class-name="root-class-name"
      :root-style="{ color: 'blue' }"
      title="AI处理流"
      :maskClosable="false"
      width="332"
      placement="right"
    >
      <div>
        <a-spin v-if="loading"></a-spin>
        <TimeLine v-else :recordList="recordList"></TimeLine>
      </div>
    </a-drawer>
    <div v-else>
      <a-spin v-if="loading"></a-spin>
      <TimeLine v-else :recordList="recordList"></TimeLine>
    </div>
  </div>
</template>

<script setup>
import { ref, defineProps, defineExpose } from 'vue'
import TimeLine from './TimeLine.vue'
import { AItrackList } from '@/api/workPlace/appoint'
const props = defineProps({
  hasDrawer: {
    type: Boolean,
    default: true
  },
  ucDoctorId: {
    type: String,
    default: ''
  },
  ucPatientId: {
    type: String,
    default: ''
  },
  workOrderId: {
    type: String,
    default: ''
  }
})
const visible = ref(false)
const recordList = ref([])
const loading = ref(false)
const showDrawer = () => {
  recordList.value = []
  visible.value = true
  loading.value = true
  const params = {
    workOrderId: props.workOrderId
  }
  AItrackList(params)
    .then(res => {
      recordList.value = res || []
    })
    .finally(() => {
      loading.value = false
    })
}

defineExpose({
  showDrawer
})
</script>
<style lang="scss" scoped>
.time {
  font-weight: 400;
  font-size: 12px;
  color: #999999;
}
.title {
  font-weight: 400;
  font-size: 16px;
  color: #1c1c1c;
}

.reocrdDrawer-content {
  ::v-deep(.ant-timeline-item-head) {
    background-color: #1890ff !important;
  }
}
</style>
